export default __webpack_public_path__ + "acf7a9190ee1f61ffb967ef97c3d4570.jpg";